define('modules/profiles/subviews/views/profile.following.menu.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/base/views/following.view",
], function (Prospector,
             $, _, Backbone, Marionette,
             FollowingView,
             Template) {
    var ProfileFollowingMenuView = FollowingView.extend({
        template: _.template("Follow"),
        tagName: 'li',
        className: "followingTxt2",
        attributes:{
          "value": "5"
        },
        initialize: function (options) {
            this.parent = options.parent;
            FollowingView.prototype.initialize.call(this, options);
        }
    });
    return ProfileFollowingMenuView;
});

